import { useMutation, gql } from "@apollo/client"
import { USER_ACCREDITATION_FIELDS } from "."

const CREATE_USER_ACCREDITATION_MUTATION = gql`
  mutation CreateUserAccreditation(
    $accreditation: ID!
    $user: ID!
  ) {
    createUserAccreditation(
      accreditation: $accreditation
      user: $user
    ) {
      ${USER_ACCREDITATION_FIELDS}
    }
  }
`

const useMutationCreateUserAccreditation = () => useMutation(CREATE_USER_ACCREDITATION_MUTATION)

export { useMutationCreateUserAccreditation }
